import type { ComponentPropsWithoutRef } from "react";
import CloseIcon from "assets/close.svg?react";
import styles from "./index.module.css";

export const CloseButton = ({
  id,
  disabled,
  onClick,
  selected,
  hasBorder = true,
  ...rest
}: {
  id?: string;
  disabled?: boolean;
  selected?: boolean;
  onClick?: () => void;
  hasBorder?: boolean;
} & ComponentPropsWithoutRef<"button">) => (
  <button
    className={styles.IconButton}
    id={id}
    disabled={disabled}
    onClick={onClick}
    type="button"
    data-selected={selected}
    data-border={hasBorder}
    {...rest}
  >
    <CloseIcon />
  </button>
);
